export default __webpack_public_path__ + "ddb5ed4b716e98fae70628cf6f26f6e0.svg";